import styled from 'styled-components';
import {
  AA_TEXT_ON_LIGHT,
  AA_LINK_ON_LIGHT,
  AA_DISABLED_BORDER,
  AA_SURFACE,
} from '~/modules/Helper/contrast.helper';

export const BarraAcoes = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
  margin-top: 6px;
`;

export const BotaoAcao = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid ${AA_DISABLED_BORDER};
  border-radius: 8px;
  background: ${AA_SURFACE};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
`;

const corPrimaria = ({ theme }) => theme?.corTema || AA_LINK_ON_LIGHT;

export const BadgeBarra = styled.span`
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  background: ${({ $ativo, theme }) => ($ativo ? corPrimaria({ theme }) : '#f0f0f0')};
  color: ${({ $ativo }) => ($ativo ? '#fff' : AA_TEXT_ON_LIGHT)};
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const IconeBarra = styled.span`
  display: inline-flex;
  font-size: 16px;
  color: ${corPrimaria};

  .anticon {
    font-size: inherit;
    color: inherit;
  }
`;

export const DrawerTabs = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;
`;

export const DrawerTab = styled.button`
  flex: 1;
  padding: 16px;
  border: none;
  background: ${({ $ativa }) => ($ativa ? '#f0f0f0' : 'transparent')};
  font-weight: ${({ $ativa }) => ($ativa ? 600 : 400)};
  font-size: 16px;
  cursor: pointer;
`;

export const BadgeTab = styled.span`
  margin-left: 8px;
  background: ${corPrimaria};
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
`;

export const ConteudoSecao = styled.div`
  padding: 16px;
`;

export const TituloSecao = styled.div`
  margin-bottom: 16px;
`;

export const LabelSecao = styled.div`
  display: block;
  margin-bottom: 8px;
`;

/* Linha com label à esquerda (ex.: "Adicionar filtro") e texto sugestivo à direita (Tipo do campo) */
export const LabelLinhaComTipo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
`;

export const CardItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
`;

export const TextoSecundario = styled.span`
  display: block;
  font-size: 12px;
  color: ${AA_TEXT_ON_LIGHT};
`;

export const BlocoForm = styled.div`
  margin-bottom: 20px;
`;

/* Tipo do campo + ícone de ajuda (à direita na mesma linha do "Adicionar filtro") */
export const TipoCampoWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.65);
`;

export const TipoCampoLabel = styled.span`
  font-weight: 600;
`;

export const TipoCampoValor = styled.span`
  color: rgba(0, 0, 0, 0.85);
`;

export const TipoCampoIcone = styled.span`
  display: inline-flex;
  color: ${AA_TEXT_ON_LIGHT};
  cursor: help;
  .anticon {
    font-size: 14px;
  }
`;

/** Label visível + controle (WCAG label_02 / 2.5.3). */
export const CampoRotulo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  width: 100%;
`;

export const CampoLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #262626;
`;
